<template>
    <v-hover v-slot:default="{ hover }">
        <span>
            <component :is="element" v-if="!edit" ref="content" @blur="save" @click="editMe" v-on:dblclick="if (!click) editMe" v-html="text ? text.replaceAll('\n','<br>'): '...'" :class="{'pa-2': edit, 'ma-0': edit, 'content-editable':edit, 'grey--background': hover}" style="min-height:50px;cursor:pointer width:100%">
            </component>
             <v-textarea v-else
                        v-model="text"
                        width="100%"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      placeholder="Opmerking..."
                      @blur="save"
                      class="body-2 pa-0 ma-0 border-less"
                    ></v-textarea>
             <v-card-actions v-if="edit">
              <v-spacer></v-spacer>
                <v-btn text @click="save">Opslaan</v-btn>
            </v-card-actions>
        </span>
    </v-hover>
</template>
<script>

export default {
  props: {
      item: {
        type: Object,
        default: () => {}
      },
      text: {
        type: String,
        default: '...'
      },
      placeholder: {
        type: String,
        default: '...'
      },
      element: {
        type: String,
        default: 'p'
      },
      click: {
          type: Boolean,
        default: true
      }
    },
   data: () => ({
       overlay: false,
       edit: false,
       alterred: false
  }),
  computed: {
    innerText () {
         return this.$refs.content.innerText 
      },
    content () {
        if (this.text && this.text.length > 1) return this.text.replaceAll('\n','<br>')
        if (this.placeholder && this.placeholder.length > 1) return this.placeholder.replaceAll('\n','<br>')
        return ''
    }
  },
  methods: {
    editMe () {
        this.edit = true
    },
    save (event){
        this.overlay=false;
        this.edit = false
        //var tt = event.target.innerText
        //console.log(this.innerText,this.text)
        //if (this.innerText == this.text) return false
        this.$emit('change',this.text,this.item)
    }
  }
}
String.prototype.replaceAll = function(target, replacement) {
  return this.split(target).join(replacement);
};
</script>
<style scoped>
 .content-editable {
     border:1px solid #e1e1e1;
 }
</style>